import { LlmModelDTO } from './llm-model.dto';
import { LlmToneDTO } from './llm-tone.dto';
import { LlmTemperatureDTO } from './llm-temperature.dto';
import {BaseDTO} from "../../../../../core/dto/BaseDTO";
import {OrganisationDTO} from "../../../../DTO/Organisation/OrganisationDTO";

export class LlmSettingsDTO extends BaseDTO {
    id?: number;
    organization: OrganisationDTO;

    welcomeMessageDefault?: string;
    welcomeMessageChatBotUi?: string;
    welcomeMessageChatWidget?: string;

    unansweredQuestionMessage?: string;
    allowGeneralKnowledgeWhenNoCorpus?: boolean;
    availableModels?: LlmModelDTO[];
    availableTones?: LlmToneDTO[];
    availableTemperatures?: LlmTemperatureDTO[];

    constructor(data?: Partial<LlmSettingsDTO>) {
        super();
        if (data) {
            this.bindData(data);
        } else {
            this.initialize();
        }
    }

    override bindData(data: Partial<LlmSettingsDTO>): void {
        if (data) {
            this.id = data.id;

            if(data.organization){
                this.organization = new OrganisationDTO();
                this.organization.bindData(data.organization);
            }

            this.welcomeMessageDefault = data.welcomeMessageDefault || '';
            this.welcomeMessageChatBotUi = data.welcomeMessageChatBotUi || '';
            this.welcomeMessageChatWidget = data.welcomeMessageChatWidget || '';

            this.unansweredQuestionMessage = data.unansweredQuestionMessage || '';
            this.allowGeneralKnowledgeWhenNoCorpus = data.allowGeneralKnowledgeWhenNoCorpus || false;

           this.availableModels=new Array<LlmModelDTO>();
            if(data.availableModels && data.availableModels.length>0){
              for (let i = 0; i < data.availableModels.length; i++) {
                let availableModelsDTO = new LlmModelDTO();
                availableModelsDTO.bindData(data.availableModels[i]);
                this.availableModels.push(availableModelsDTO);
              }
            }
          this.availableTones=new Array<LlmToneDTO>();
          if(data.availableTones && data.availableTones.length>0){
            for (let i = 0; i < data.availableTones.length; i++) {
              let availableTonesDTO = new LlmToneDTO();
              availableTonesDTO.bindData(data.availableTones[i]);
              this.availableTones.push(availableTonesDTO);
            }
          }
          this.availableTemperatures=new Array<LlmTemperatureDTO>();
          if(data.availableTemperatures && data.availableTemperatures.length>0){
            for (let i = 0; i < data.availableTemperatures.length; i++) {
              let availableTemperaturesDTO = new LlmTemperatureDTO();
              availableTemperaturesDTO.bindData(data.availableTemperatures[i]);
              this.availableTemperatures.push(availableTemperaturesDTO);
            }
          }
        }
    }

    private initialize(): void {
        this.organization = new OrganisationDTO();

        this.welcomeMessageDefault = '';
        this.welcomeMessageChatBotUi = '';
        this.welcomeMessageChatWidget = '';

        this.unansweredQuestionMessage = '';
        this.allowGeneralKnowledgeWhenNoCorpus = false;
        this.availableModels = [];
        this.availableTones = [];
        this.availableTemperatures = [];
    }

    override equals(other: any): boolean {
        if (!(other instanceof LlmSettingsDTO)) {
            return false;
        }
        return this.id === other.id;
    }

    override toCreatorInformationString(): string {
        return `LLM Settings for Organization ${this.organization.id}`;
    }
}
